import { observer } from 'mobx-react';
import * as React from 'react';
import { EitherLearningCollectionStore } from '../LearningCollections/Types';
import WizardSteps from './WizardSteps';

interface Props {
  store: EitherLearningCollectionStore;
}

const WizardStepGroup: React.FC<Props> = ({ store }) => (
  <div className="flex w-2/3 items-center justify-center py-2">
    <div className="flex w-full place-content-center place-items-center gap-2.5">
      {store.wizardItems
        .map((items) => <WizardSteps items={items} />)
        .getOrElse(() => (
          <></>
        ))}
    </div>
  </div>
);

export default observer(WizardStepGroup);
